const colMap = {
  1: 'grid-cols-1',
  2: 'grid-cols-1 sm:grid-cols-2',
  3: 'grid-cols-1 md:grid-cols-3',
  4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
};

const gapMap = {
  4: 'gap-4',
  6: 'gap-6',
  8: 'gap-8',
};

export function Container({ className = '', children, ...props }) {
  return (
    <div className={['max-w-7xl mx-auto px-4 sm:px-6', className].join(' ')} {...props}>
      {children}
    </div>
  );
}

export function Grid({ cols = 1, gap = 6, className = '', children, ...props }) {
  return (
    <div
      className={['grid', colMap[cols] || colMap[1], gapMap[gap] || gapMap[6], className].join(' ')}
      {...props}
    >
      {children}
    </div>
  );
}

export function Flex({ className = '', children, ...props }) {
  return (
    <div className={['flex', className].join(' ')} {...props}>
      {children}
    </div>
  );
}

export function Stack({ gap = 4, className = '', children, ...props }) {
  const gapClass = gapMap[gap] || gapMap[4];
  return (
    <div className={['flex flex-col', gapClass, className].join(' ')} {...props}>
      {children}
    </div>
  );
}

export function Divider({ className = '', ...props }) {
  return (
    <hr
      className={['border-neutral-200 dark:border-neutral-700', className].join(' ')}
      {...props}
    />
  );
}
